module.exports = __webpack_public_path__ + "img/BecomePan-2.e5f8f28d.svg";